import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { AesRandomizerService } from './randomizer_service/aes-randomizer.service';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo:
      localStorage.getItem(AesRandomizerService.pnkyStr) &&
        Capacitor.getPlatform() === 'android'
        ? 'pinlogin'
        : 'mod0502',
    pathMatch: 'full',
  },
  // {
  //   path: 'mod0133',
  //   loadChildren: () =>
  //     import('./mod0133/mod0133.module').then((m) => m.Mod0133PageModule),
  // },
  {
    path: 'pinlogin',
    loadChildren: () =>
      import('./pinlogin/pinlogin.module').then((m) => m.PinloginPageModule),
  },

  {
    path: 'mod0502',
    loadChildren: () =>
      import('./mod0502/mod0502.module').then((m) => m.Mod0502PageModule),
  },
  {
    path: 'mod0101',
    loadChildren: () =>
      import('./mod0101/mod0101.module').then((m) => m.Mod0101PageModule),
  },
  // {
  //   path: 'mod0174',
  //   loadChildren: () =>
  //     import('./mod0174/mod0174.module').then((m) => m.Mod0174PageModule),
  // },
  {
    path: 'mod0123',
    loadChildren: () =>
      import('./mod0123/mod0123.module').then((m) => m.Mod0123PageModule),
  },
  {
    path: 'mod0103',
    loadChildren: () =>
      import('./mod0103/mod0103.module').then((m) => m.Mod0103PageModule),
  },
  {
    path: 'mod0102',
    loadChildren: () =>
      import('./mod0102/mod0102.module').then((m) => m.Mod0102PageModule),
  },

  // {
  //   path: 'scanner',
  //   loadChildren: () =>
  //     import('./scanner/scanner.module').then((m) => m.ScannerPageModule),
  // },
  {
    path: 'master',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./mastermodule/mastermodule.module').then(
            (m) => m.MastermodulePageModule,
          ),
      },


      // {
      //   path: 'mod0106',
      //   loadChildren: () =>
      //     import('./mod0106/mod0106.module').then((m) => m.Mod0106PageModule),
      // },
      // {
      //   path: 'admission',
      //   loadChildren: () =>
      //     import('./admission/admission.module').then(
      //       (m) => m.AdmissionPageModule,
      //     ),
      // },
      // {
      //   path: 'mod0115',
      //   loadChildren: () =>
      //     import('./mod0115/mod0115.module').then((m) => m.Mod0115PageModule),
      // },
      // {
      //   path: 'mod0116',
      //   loadChildren: () =>
      //     import('./mod0116/mod0116.module').then((m) => m.Mod0116PageModule),
      // },
      // {
      //   path: 'exam',
      //   loadChildren: () =>
      //     import('./exam/exam.module').then((m) => m.ExamPageModule),
      // },
      // {
      //   path: 'mod0305',
      //   loadChildren: () =>
      //     import('./mod0305/mod0305.module').then((m) => m.Mod0305PageModule),
      // },
      // {
      //   path: 'mod0401',
      //   loadChildren: () =>
      //     import('./mod0401/mod0401.module').then((m) => m.Mod0401PageModule),
      // },

      // {
      //   path: 'mod0125',
      //   loadChildren: () =>
      //     import('./mod0125/mod0125.module').then((m) => m.Mod0125PageModule),
      // },
      // {
      //   path: 'mod0127',
      //   loadChildren: () =>
      //     import('./mod0127/mod0127.module').then((m) => m.Mod0127PageModule),
      // },
      // {
      //   path: 'mod0130',
      //   loadChildren: () =>
      //     import('./mod0130/mod0130.module').then((m) => m.Mod0130PageModule),
      // },
      // {
      //   path: 'mod0131',
      //   loadChildren: () =>
      //     import('./mod0131/mod0131.module').then((m) => m.Mod0131PageModule),
      // },
      // {
      //   path: 'mod0132',
      //   loadChildren: () =>
      //     import('./mod0132/mod0132.module').then((m) => m.Mod0132PageModule),
      // },
      // {
      //   path: 'mod0133',
      //   loadChildren: () =>
      //     import('./mod0133/mod0133.module').then((m) => m.Mod0133PageModule),
      // },
      // {
      //   path: 'mod0135',
      //   loadChildren: () =>
      //     import('./mod0135/mod0135.module').then((m) => m.Mod0135PageModule),
      // },
      // {
      //   path: 'accounts',
      //   loadChildren: () =>
      //     import('./accounts/accounts.module').then(
      //       (m) => m.AccountsPageModule,
      //     ),
      // },
      // {
      //   path: 'reports',
      //   loadChildren: () =>
      //     import('./reports/reports.module').then((m) => m.ReportsPageModule),
      // },
      // {
      //   path: 'mod0144',
      //   loadChildren: () =>
      //     import('./mod0144/mod0144.module').then((m) => m.Mod0144PageModule),
      // },
      // {
      //   path: 'mod0146',
      //   loadChildren: () =>
      //     import('./mod0146/mod0146.module').then((m) => m.Mod0146PageModule),
      // },
      // {
      //   path: 'mod0166',
      //   loadChildren: () =>
      //     import('./mod0166/mod0166.module').then((m) => m.Mod0166PageModule),
      // },
      // {
      //   path: 'mod0175',
      //   loadChildren: () =>
      //     import('./mod0175/mod0175.module').then((m) => m.Mod0175PageModule),
      // },


      // {
      //   path: 'billing',
      //   loadChildren: () =>
      //     import('./billing/billing.module').then((m) => m.BillingPageModule),
      // },

      // {
      //   path: 'mod0176',
      //   loadChildren: () =>
      //     import('./mod0176/mod0176.module').then((m) => m.Mod0176PageModule),
      // },
      // {
      //   path: 'mod0177',
      //   loadChildren: () =>
      //     import('./mod0177/mod0177.module').then((m) => m.Mod0177PageModule),
      // },
      // {
      //   path: 'mod0184',
      //   loadChildren: () =>
      //     import('./mod0184/mod0184.module').then((m) => m.Mod0184PageModule),
      // },

      {
        path: 'mod0119',
        loadChildren: () =>
          import('./mod0119/mod0119.module').then((m) => m.Mod0119PageModule),
      },
      {
        path: 'mod0185',
        loadChildren: () =>
          import('./mod0185/mod0185.module').then((m) => m.Mod0185PageModule),
      },

      // {
      //   path: 'mod0411',
      //   loadChildren: () =>
      //     import('./mod0411/mod0411.module').then((m) => m.Mod0411PageModule),
      // },
      // {
      //   path: 'mod0412',
      //   loadChildren: () =>
      //     import('./mod0412/mod0412.module').then((m) => m.Mod0412PageModule),
      // },

      // {
      //   path: 'mod0416',
      //   loadChildren: () =>
      //     import('./mod0416/mod0416.module').then((m) => m.Mod0416PageModule),
      // },
      // {
      //   path: 'mod0417',
      //   loadChildren: () =>
      //     import('./mod0417/mod0417.module').then((m) => m.Mod0417PageModule),
      // },
      // {
      //   path: 'mod0418',
      //   loadChildren: () =>
      //     import('./mod0418/mod0418.module').then((m) => m.Mod0418PageModule),
      // },
      // {
      //   path: 'mod0419',
      //   loadChildren: () =>
      //     import('./mod0419/mod0419.module').then((m) => m.Mod0419PageModule),
      // },
      // {
      //   path: 'dashboard',
      //   loadChildren: () =>
      //     import('./dashboard/dashboard.module').then(
      //       (m) => m.DashboardPageModule,
      //     ),
      // },
      // {
      //   path: 'mod0420',
      //   loadChildren: () =>
      //     import('./mod0420/mod0420.module').then((m) => m.Mod0420PageModule),
      // },
      // {
      //   path: 'mod0264',
      //   loadChildren: () =>
      //     import('./mod0264/mod0264.module').then((m) => m.Mod0264PageModule),
      // },
      // {
      //   path: 'mod0263',
      //   loadChildren: () =>
      //     import('./mod0263/mod0263.module').then((m) => m.Mod0263PageModule),
      // },
      // {
      //   path: 'mod0473',
      //   loadChildren: () => import('./mod0473/mod0473.module').then( m => m.Mod0473PageModule)
      // },
      // {
      //   path: 'mod0189',
      //   loadChildren: () =>
      //     import('./mod0189/mod0189.module').then((m) => m.Mod0189PageModule),
      // },
      // {
      //   path: 'mod0265',
      //   loadChildren: () =>
      //     import('./mod0265/mod0265.module').then((m) => m.Mod0265PageModule),
      // },
      // {
      //   path: 'mod0279',
      //   loadChildren: () =>
      //     import('./mod0279/mod0279.module').then((m) => m.Mod0279PageModule),
      // },
      // {
      //   path: 'mod0268',
      //   loadChildren: () =>
      //     import('./mod0268/mod0268.module').then((m) => m.Mod0268PageModule),
      // },
      {
        path: 'mod0275',
        loadChildren: () =>
          import('./mod0275/mod0275.module').then((m) => m.Mod0275PageModule),
      },
      {
        path: 'mod0274',
        loadChildren: () =>
          import('./mod0274/mod0274.module').then((m) => m.Mod0274PageModule),
      },
      // {
      //   path: 'mod0276',
      //   loadChildren: () =>
      //     import('./mod0276/mod0276.module').then((m) => m.Mod0276PageModule),
      // },
      {
        path: 'mod0277',
        loadChildren: () =>
          import('./mod0277/mod0277.module').then((m) => m.Mod0277PageModule),
      },
      {
        path: 'mod0278',
        loadChildren: () =>
          import('./mod0278/mod0278.module').then((m) => m.Mod0278PageModule),
      },
      // {
      //   path: 'mod0190',
      //   loadChildren: () =>
      //     import('./mod0190/mod0190.module').then((m) => m.Mod0190PageModule),
      // },
      // {
      //   path: 'mod0191',
      //   loadChildren: () =>
      //     import('./mod0191/mod0191.module').then((m) => m.Mod0191PageModule),
      // },

      // {
      //   path: 'mod0500',
      //   loadChildren: () =>
      //     import('./mod0500/mod0500.module').then((m) => m.Mod0500PageModule),
      // },

      // {
      //   path: 'mod0501',
      //   loadChildren: () =>
      //     import('./mod0501/mod0501.module').then((m) => m.Mod0501PageModule),
      // },
    ],
  },
  {
    path: 'mod0503',
    loadChildren: () => import('./mod0503/mod0503.module').then(m => m.Mod0503PageModule)
  },




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
